import React from 'react';
import { Award, BookOpen, Flame, Gem, GraduationCap, Map, Star, Target, Zap } from 'lucide-react';

// Les badges sont enregistrés en base avec un emoji : on l'affiche en icône SVG.
const ICONES = {
  '🔥': Flame, '⭐': Star, '🗺': Map, '🎓': GraduationCap, '🎯': Target,
  '💎': Gem, '⚡': Zap, '📚': BookOpen, '🏅': Award,
};

const BadgeIcon = ({ icon, className = 'w-8 h-8 mx-auto' }) => {
  const Icon = ICONES[String(icon || '').replace('️', '')] || Award;
  return <Icon className={className} aria-hidden="true" />;
};

export default BadgeIcon;
